var _path, _path2, _g, _g2, _g3, _rect, _path3, _rect2, _path4, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceDailyFlossing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 145,
    viewBox: "0 0 296 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 2L257 16",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M199 120.5L191 131.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9775)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.9463,
    y: 56.7744,
    width: 46.7692,
    height: 46.7692,
    rx: 3.25275,
    transform: "rotate(-10 18.9463 56.7744)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0363,
    cy: 75.7435,
    r: 17.2308,
    transform: "rotate(-10 46.0363 75.7435)",
    stroke: "white",
    strokeWidth: 1.23077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0362,
    cy: 75.743,
    r: 7.38462,
    transform: "rotate(-10 46.0362 75.743)",
    stroke: "white",
    strokeWidth: 1.23077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7808 44.5133C31.7218 44.1786 31.4026 43.9551 31.0679 44.0141C30.7332 44.0731 30.5098 44.3923 30.5688 44.727L31.7808 44.5133ZM36.7711 48.0075C34.4282 48.4206 32.194 46.8562 31.7808 44.5133L30.5688 44.727C31.0999 47.7393 33.9725 49.7507 36.9848 49.2196L36.7711 48.0075Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1495 43.8046L36.8779 48.6133",
    stroke: "#2392F8",
    strokeWidth: 1.23077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0737 54.7132L43.6504 58.667",
    stroke: "white",
    strokeWidth: 1.23077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0732 54.7139L67.8913 54.3933C70.9037 53.8621 72.9151 50.9896 72.3839 47.9772V47.9772C71.8528 44.9649 68.9802 42.9535 65.9679 43.4846L64.1498 43.8052",
    stroke: "#2392F8",
    strokeWidth: 1.23077
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9775)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.946,
    y: 56.7744,
    width: 46.7692,
    height: 46.7692,
    rx: 3.25275,
    transform: "rotate(-10 114.946 56.7744)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.036,
    cy: 75.7435,
    r: 17.2308,
    transform: "rotate(-10 142.036 75.7435)",
    stroke: "white",
    strokeWidth: 1.23077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.036,
    cy: 75.743,
    r: 7.38462,
    transform: "rotate(-10 142.036 75.743)",
    stroke: "white",
    strokeWidth: 1.23077,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.781 44.5133C127.722 44.1786 127.403 43.9551 127.068 44.0141C126.733 44.0731 126.51 44.3923 126.569 44.727L127.781 44.5133ZM132.771 48.0075C130.428 48.4206 128.194 46.8562 127.781 44.5133L126.569 44.727C127.1 47.7393 129.972 49.7507 132.985 49.2196L132.771 48.0075Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.15 43.8046L132.878 48.6133",
    stroke: "#2392F8",
    strokeWidth: 1.23077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.074 54.7132L139.65 58.667",
    stroke: "white",
    strokeWidth: 1.23077
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.073 54.7139L163.891 54.3933C166.904 53.8621 168.915 50.9896 168.384 47.9772V47.9772C167.853 44.9649 164.98 42.9535 161.968 43.4846L160.15 43.8052",
    stroke: "#2392F8",
    strokeWidth: 1.23077
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9775)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.183,
    y: 48.9678,
    width: 58.4615,
    height: 58.4615,
    rx: 4.06593,
    transform: "rotate(-10 204.183 48.9678)",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.045,
    cy: 72.6791,
    r: 21.5385,
    transform: "rotate(-10 238.045 72.6791)",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.045,
    cy: 72.679,
    r: 9.23077,
    transform: "rotate(-10 238.045 72.679)",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.226 33.6408C220.153 33.2225 219.754 32.9431 219.335 33.0169C218.917 33.0906 218.637 33.4896 218.711 33.908L220.226 33.6408ZM226.464 38.0086C223.535 38.525 220.743 36.5695 220.226 33.6408L218.711 33.908C219.375 37.6734 222.966 40.1877 226.731 39.5237L226.464 38.0086Z",
    fill: "#2392F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.687 32.7557L226.598 38.7666",
    stroke: "#2392F8",
    strokeWidth: 1.53846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.093 46.3917L235.063 51.334",
    stroke: "white",
    strokeWidth: 1.53846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.092 46.3916L265.364 45.9909C269.13 45.3269 271.644 41.7362 270.98 37.9708V37.9708C270.316 34.2054 266.725 31.6911 262.96 32.3551L260.687 32.7558",
    stroke: "#2392F8",
    strokeWidth: 1.53846
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 86,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.5 102L170.5 106L177.5 98",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 86,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 102L74.5 106L81.5 98",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 86,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 102,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 102,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 102,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129,
    cy: 134,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 22,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 20.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 143.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 38.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 32.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 12.5L201.5 26",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.5 129L251 142",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(8.93066 46.043) rotate(-10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(104.931 46.043) rotate(-10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(191.663 35.5537) rotate(-10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceDailyFlossing);
export default __webpack_public_path__ + "static/media/persistence-daily-flossing.a69a5efa0e46f3d239fce3891b9d4f11.svg";
export { ForwardRef as ReactComponent };